import { render, staticRenderFns } from "./StockStallionDetails.vue?vue&type=template&id=df57cb6a&"
import script from "./StockStallionDetails.vue?vue&type=script&lang=js&"
export * from "./StockStallionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports